<h3>{{ 'GLOBAL.CHANGEPASSWORD.HEADER' | translate }}</h3>

<span [ngClass]="loading ? 'icon-spinner icon-spin' : ''"></span>

@if (!passwordChanged && !loading) {
  <form
    [formGroup]="changePasswordForm"
    (ngSubmit)="clickSubmit()"
    (keydown.enter)="$event.preventDefault()">
    <!-- @todo: Evtl noch ein hidden username-Field hinzufügen. Für Passwortmanager-Accessibility-Funktionalität
    https://www.chromium.org/developers/design-documents/create-amazing-password-forms -->
    <div class="form-group cw-password-field">
      <input
        formControlName="password_old"
        id="password_old"
        [type]="showPasswordOld ? 'text' : 'password'"
        class="form-control cw-login-input"
        placeholder="{{ 'GLOBAL.CHANGEPASSWORD.PASSWORDOLD' | translate }}"
        autocomplete="current-password" />
      <button type="button" class="cw-password-toggle" (click)="showPasswordOld = !showPasswordOld" tabindex="-1">
        <fa-icon [icon]="showPasswordOld ? 'eye-slash' : 'eye'"></fa-icon>
      </button>
    </div>
    <div class="form-group cw-password-field">
      <input
        formControlName="password_new"
        id="password_new"
        [type]="showPasswordNew ? 'text' : 'password'"
        class="form-control cw-login-input"
        placeholder="{{ 'GLOBAL.CHANGEPASSWORD.PASSWORDNEW' | translate }}"
        autocomplete="new-password" />
      <button type="button" class="cw-password-toggle" (click)="showPasswordNew = !showPasswordNew" tabindex="-1">
        <fa-icon [icon]="showPasswordNew ? 'eye-slash' : 'eye'"></fa-icon>
      </button>
    </div>
    <div class="form-group cw-password-field">
      <input
        formControlName="password_new_confirm"
        id="password_new_confirm"
        [type]="showPasswordConfirm ? 'text' : 'password'"
        class="form-control cw-login-input"
        placeholder="{{ 'GLOBAL.CHANGEPASSWORD.PASSWORDREPEAT' | translate }}"
        autocomplete="new-password" />
      <button type="button" class="cw-password-toggle" (click)="showPasswordConfirm = !showPasswordConfirm" tabindex="-1">
        <fa-icon [icon]="showPasswordConfirm ? 'eye-slash' : 'eye'"></fa-icon>
      </button>
    </div>
    @if (backendErrorCodes.saltedMatch || backendErrorCodes.noReuse || backendErrorCodes.rulesViolated) {
      <div
        class="cw-color-orange cw-login-error"
        >
        @if (backendErrorCodes.rulesViolated === true) {
          <p>
            <span class="cw-password-security-icon icon-close error"></span
              >{{ 'GLOBAL.CHANGEPASSWORD.PASSWORDRULESVIOLATED' | translate }}
            </p>
          }
          @if (backendErrorCodes.saltedMatch === true) {
            <p>
              <span class="cw-password-security-icon icon-close error"></span
                >{{ 'GLOBAL.CHANGEPASSWORD.WRONGPASSWORD' | translate }}
              </p>
            }
            @if (backendErrorCodes.noReuse === true) {
              <p>
                <span class="cw-password-security-icon icon-close error"></span
                  >{{ 'GLOBAL.CHANGEPASSWORD.PASSWORDALREADYUSED' | translate }}
                </p>
              }
            </div>
          }
          @if (!saving) {
            <div class="cw-password-security-message">
              <span
                class="cw-password-security-icon"
            [ngClass]="{
                'icon-check correct':
                    !changePasswordForm.controls.password_new.errors?.minlength &&
                    !(changePasswordForm.controls.password_new.value | isUndefined) &&
                    changePasswordForm.controls.password_new.value !== '',
                'icon-close error':
                    changePasswordForm.controls.password_new.errors?.minlength ||
                    (changePasswordForm.controls.password_new.value | isUndefined) ||
                    changePasswordForm.controls.password_new.value === ''
            }"></span>
              {{ 'GLOBAL.CHANGEPASSWORD.MINIMUMLENGTH' | translate: {minimumLength: minimumLength} }}
            </div>
          }
          @for (rule of validationRules; track rule) {
            <div>
              @if (!saving) {
                <div class="cw-password-security-message">
                  <span
                    class="cw-password-security-icon"
                [ngClass]="{
                    'icon-check correct':
                        (changePasswordForm.controls.password_new.errors | isUndefined) ||
                        !changePasswordForm.controls.password_new.errors[rule.rule_name],
                    'icon-close error':
                        !(changePasswordForm.controls.password_new.errors | isUndefined) &&
                        changePasswordForm.controls.password_new.errors[rule.rule_name]
                }"></span>
                  {{ rule['rule_text_' + translateService.currentLang] }}
                </div>
              }
            </div>
          }
          @if (!saving && minimumEditDistance !== null) {
            <div class="cw-password-security-message">
              <span
                class="cw-password-security-icon"
            [ngClass]="{
                'icon-check correct': !changePasswordForm.errors?.newPasswordTooSimilar,
                'icon-close error': changePasswordForm.errors?.newPasswordTooSimilar,
            }">
              </span>
              {{
              (changePasswordForm.errors?.newPasswordTooSimilar
              ? 'GLOBAL.CHANGEPASSWORD.NEWPASSWORDTOOSIMILAR'
              : 'GLOBAL.CHANGEPASSWORD.NEWPASSWORDSUFFICIENTLYCHANGED'
              ) | translate
              }}
            </div>
          }
          @if (!saving) {
            <div class="cw-password-security-message">
              <span
                class="cw-password-security-icon"
            [ngClass]="{
                'icon-check correct': !changePasswordForm.errors?.passwordsDontMatch,
                'icon-close error': changePasswordForm.errors?.passwordsDontMatch
            }"></span>
              {{ 'GLOBAL.CHANGEPASSWORD.NEWPASSWORDSMATCH' | translate }}
            </div>
          }
          <div class="cw-button-wrapper">
            <button
              mat-raised-button
              color="accent"
              type="submit"
              class="cw-login-button"
              [disabled]="saving || !changePasswordForm.valid">
              {{ 'GLOBAL.CHANGEPASSWORD.ACTION' | translate }}
              <span [ngClass]="saving ? 'icon-spinner icon-spin' : ''"></span>
            </button>
            @if (!disableClose) {
              <button mat-raised-button color="primary" type="button" (click)="clickAndClose()">
                {{ 'GENERAL.CANCEL' | translate }}
              </button>
            }
          </div>
        </form>
      }

      @if (passwordChanged) {
        <div class="cw-color-orange cw-login-error">
          <span>{{ 'GLOBAL.CHANGEPASSWORD.SUCCESS' | translate }}</span>
        </div>
        <div class="cw-button-wrapper">
          <button mat-raised-button color="primary" type="button" (click)="clickAndClose()">
            {{ 'GENERAL.CLOSE' | translate }}
          </button>
        </div>
      }
